// Add Vuex Store keys here
export const state = () => ({
  partner: null,
})

export const mutations = {
  setPartner(state, value) {
    state.partner = value
  },
}

export const actions = {
  async getPartner({ state, commit }, queryProps) {
    // commit('setIsLoading', true)
    const apiResult = await this.$apiAaltra.getSolutions(
      queryProps?.country,
      queryProps?.language,
      queryProps?.tbsId
    )

    if (apiResult && apiResult?.partner) {
      await commit('setPartner', apiResult?.partner)
      // commit('setIsLoading', false)
    } else {
      await commit('setPartner', null)
      // commit('setIsLoading', false)
    }
  }
}
